import { faAngleDown, faChartLine, faHouse, faHandshake } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import constants from "../constants/constants";
import SEO, { pageSEO } from "../components/seo.component";
import { motion } from "framer-motion";
import { fadeUp, stagger } from "../functions/animations";

export default function SellerGuide() {
  const [open, setOpen] = useState(
    new Array(constants.SELLING_GUIDE.length).fill(false)
  );

  const seoConfig = pageSEO.sellerGuide();

  const toggleAccordion = (index) => {
    const temp = [...open];
    temp[index] = !temp[index];
    setOpen(temp);
  };

  return (
    <>
      <SEO {...seoConfig} />

      {/* HERO */}
      <section className="relative overflow-hidden bg-cottage-secondary pt-40 pb-28">
        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          className="relative mx-auto max-w-[1200px] px-6 bg-cottage-secondary/20"
        >
          <div className="mb-16 text-center">
            <motion.p
              variants={fadeUp}
              className="uppercase tracking-[0.5em] font-semibold text-cottage-accent"
            >
              Home Selling Journey
            </motion.p>

            <motion.h1
              variants={fadeUp}
              className="mt-8 font-serif text-5xl leading-tight text-cottage-primary md:text-6xl"
            >
              Sell With
              <br />
              Confidence
            </motion.h1>

            <motion.p
              variants={fadeUp}
              className="mx-auto mt-8 max-w-2xl text-lg leading-8 text-cottage-muted"
            >
              Discover the strategies, preparation steps, and expert guidance
              needed to position your property for success and achieve the best
              possible results.
            </motion.p>
          </div>
        </motion.div>
      </section>

      {/* CONTENT */}
      <section className="mx-auto max-w-[1400px] px-6 py-24">
        <div className="grid gap-12 lg:grid-cols-[280px_1fr]">
          <motion.div variants={fadeUp} className="hidden lg:block">
            <div className="sticky top-32 rounded-[32px] bg-cottage-primary p-8 text-white">
              <FontAwesomeIcon
                icon={faChartLine}
                className="text-3xl text-cottage-highlight"
              />

              <h3 className="mt-8 font-heading text-3xl">
                Maximize
                <br />
                Your Value
              </h3>

              <p className="mt-5 text-sm leading-7 text-white/70">
                Learn how preparation, presentation, and strategic marketing
                can help your home stand out in today's market.
              </p>

              <div className="mt-8 space-y-5 text-sm uppercase tracking-wider">
                <div className="flex items-center gap-3">
                  <FontAwesomeIcon
                    icon={faHouse}
                    className="text-cottage-highlight"
                  />
                  Prepare Your Home
                </div>

                <div className="flex items-center gap-3">
                  <FontAwesomeIcon
                    icon={faHandshake}
                    className="text-cottage-highlight"
                  />
                  Complete Your Sale
                </div>
              </div>
            </div>
          </motion.div>

          <div className="space-y-5">
            {constants.SELLING_GUIDE.map((guide, index) => (
              <motion.div
                variants={fadeUp}
                key={index}
                className="overflow-hidden rounded-[28px] border border-cottage-border bg-white shadow-sm transition hover:shadow-xl"
              >
                <button
                  onClick={() => toggleAccordion(index)}
                  className="group flex w-full items-center justify-between px-7 py-7 text-left md:px-10"
                >
                  <div className="flex items-center gap-5">
                    <div className="flex h-12 w-12 items-center justify-center rounded-full bg-cottage-secondary text-cottage-primary shrink-0">
                      <span className="text-sm font-semibold">
                        {String(index + 1).padStart(2, "0")}
                      </span>
                    </div>

                    <h2 className="font-heading text-2xl text-cottage-primary transition group-hover:text-cottage-accent md:text-3xl">
                      {guide.heading}
                    </h2>
                  </div>

                  <FontAwesomeIcon
                    icon={faAngleDown}
                    className={`text-cottage-accent transition-transform duration-300 ${open[index] ? "rotate-180" : ""
                      }`}
                  />
                </button>

                <div
                  className={`grid transition-all duration-500 ease-in-out ${open[index]
                    ? "grid-rows-[1fr]"
                    : "grid-rows-[0fr]"
                    }`}
                >
                  <div className="overflow-hidden">
                    <div className="border-t border-cottage-border px-7 pb-8 pt-6 leading-8 text-cottage-muted md:px-10">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: guide.text,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>

      </section >
    </>
  );
}